/*


START slideShow.js
__________________



*/



/*REQUIRES the following JS:
 * Jquery
 * TimelineLite
 * 
 * ('.slideShow>img') HTML format
 * *** MUST BE LOCATED AT BOTTOM!!!
 */





var timers = {
    preloadDelayTime: 1000, //in ms
    slideFrequency: 2750, //in ms
    slideFrequencySM: 4250, //in ms
    slideTimeScale: 1.37, //1.3, //1=100% Slide Speed, 2=200% Slide Speed
    slideTimeScaleSM: 1.65, //1.5, //1=100% Slide Speed, 2=200% Slide Speed
    preloaderDelay: null,
    usedTimeScale: null,
    resizeDelay: null,
    slideTimer: null,
    pickImageTimeout: null,
    setSlideTimer: function(localSlideTimer) { timers.slideTimer = setInterval(playSlideShow, localSlideTimer); } //setSlideTimer -- STARTS THE SLIDE SHOW INTERVAL
};

var arrays = {
    slideArray: $('.slideShow:visible'),
    imageArray: [], //Currently Loaded by 'Image Array Constructor'
    loadedArray: [],
    loadedArrayTarget: null,
    lastArrayTarget: null,
    newArrayTarget: null
};

var slide = {
    maxSlide: arrays.slideArray.length,
    currentSlide: null
        //newSlide: null
};

var imgObj = {}; //Populated by self Executing buildImgObj()

var imageTools = {
    maxImage: arrays.imageArray.length,
    totalImagesLoaded: 0,
    lastImage1: null,
    lastImage2: null,
    lastImage3: null,
    currentImage: null,
    newImage: null,
    targetImage: null // usable in slideShowImage

};

var misc = {
    previousWidth: null,
    currentWidth: null,
    imageCount: 1,
    initiateSlideSwitchOn: false
};









//IMG ARRAY CONSTRUCTOR
(function imageArrayConstructor() {
    var imageCount = 15; //Determines how many images are to be looked for in the slideshow
    for (var i = 1; i <= imageCount; i++) {
        var newArrayItem;
        if (i < 10) {
            newArrayItem = 'img/slides/slideShow_0' + i + '.png';
        } else {
            newArrayItem = 'img/slides/slideShow_' + i + '.png';
        }
        arrays.imageArray.push(newArrayItem);
    }
})(); //IMG ARRAY CONSTRUCTOR





//randomInt -- RANDOM NUMBER GENERATOR
function randomInt(min, max, not) {
    var int;
    do { int = Math.floor(Math.random() * (max - min + 1) + min); }
    while (int === not);

    return int;
} //randomInt -- RANDOM NUMBER GENERATOR



//pickSlide -- PICKS THE SLIDE TO DISPLAY ON, IF MORE THAN 1 IT MAKES SURE THE NEW SLIDE IS DIFFERENT THAN THE LAST ONE
function pickSlide(thisImg) {
    var newSlide;
    if (slide.maxSlide === 1) {
        newSlide = 0;
    } else {
        newSlide = randomInt(0, slide.maxSlide - 1, slide.currentSlide);
    }

    slide.currentSlide = newSlide;
    return newSlide;
} //pickSlide -- PICKS THE SLIDE TO DISPLAY ON, IF MORE THAN 1 IT MAKES SURE THE NEW SLIDE IS DIFFERENT THAN THE LAST ONE




//slideController -- imgObj.img# METHOD - PICKS SLIDE, ADDS IMAGE OBJECT TO DOM, ANIMATES IMAGE, onComplete - REMOVE IMAGE AND KILL ANIMATION
function slideController() {
    this.runningSlide = pickSlide(this); //Returns Array location for the running Slide
    arrays.slideArray[this.runningSlide].appendChild(this); //Add to DOM
    this.animateImage = new TimelineLite();
    var targetImage = this
    targetImage.animateImage.fromTo(targetImage, 9, { position: 'absolute', top: '100%', left: 0, right: 0, opacity: 0 }, { top: '-100%', ease: SlowMo.ease.config(0.3, 0.7, false), y: 50 }, 0)
        .to(targetImage, 3, { opacity: 1, ease: Power0.easeNone }, 0)
        .to(targetImage, 1, { opacity: 0, ease: Power0.easeNone }, 8)
        .to(targetImage, 1, {
            display: 'none',
            onComplete: function() {
                if (targetImage.runningSlide !== null) {
                    targetImage.runningSlide = null;
                    targetImage.style.display = '';
                    targetImage.parentNode.removeChild(targetImage);
                    targetImage.animateImage.kill();
                    targetImage.animateImage = false;
                }
            }
        }, 9)
        .timeScale(timers.usedTimeScale);
} //slideController -- imgObj.img# METHOD - PICKS SLIDE, ADDS IMAGE OBJECT TO DOM, ANIMATES IMAGE, onComplete - REMOVE IMAGE AND KILL ANIMATION



//pickImage -- PICKS A NEW IMAGE FROM THE totalImagesLoaded ARRAY, CHECKS TO SEE IF IT HAS BEEN USED LATELY AND IS LOADED.
function playSlideShow() {
    if (misc.initiateSlideSwitchOn) { return }
    if (arrays.slideArray.length = 3) {
        if ($('.slideShow>img').length > arrays.slideArray.length) {
            clearInterval(timers.slideTimer);
            timers.slideTimer = null;
            initiateSlides();

            return;
        }

    }else{
        if ($('.slideShow>img').length > arrays.slideArray.length + 1) {
            clearInterval(timers.slideTimer);
            timers.slideTimer = null;
            initiateSlides();

            return;
        }

    }


    // arrays.newArrayTarget= randomInt(0, imageTools.totalImagesLoaded - 1);
    //arrays.lastArrayTarget= arrays.newArrayTarget;
    arrays.loadedArrayTarget = arrays.loadedArray[randomInt(0, imageTools.totalImagesLoaded - 1)]; //Pick random image array value from arays.loadedArray 

    if ((imageTools.currentImage === arrays.loadedArrayTarget) || (imageTools.lastImage1 === arrays.loadedArrayTarget) || (imageTools.lastImage2 === arrays.loadedArrayTarget) || (imageTools.lastImage3 === arrays.loadedArrayTarget)) {
        timers.pickImageTimeout = setTimeout(playSlideShow, 100);

    } else if (!arrays.loadedArrayTarget.loaded) {
        timers.pickImageTimeout = setTimeout(playSlideShow, 250);

    } else {
        imageTools.lastImage3 = imageTools.lastImage2;
        imageTools.lastImage2 = imageTools.lastImage1;
        imageTools.lastImage1 = imageTools.currentImage;
        imageTools.currentImage = arrays.loadedArrayTarget;

        arrays.loadedArrayTarget.play();

    }

} //pickImage -- PICKS A NEW IMAGE FROM THE totalImagesLoaded ARRAY, CHECKS TO SEE IF IT HAS BEEN USED LATELY (LAST 4 TIMES) AND IS LOADED.



//startLargeorSmall -- CHANGES THE SPEED OF THE SLIDE SHOW DEPENDING ON maxSlide
function startLargeorSmall() {

    misc.initiateSlideSwitchOn = false;

    if (timers.slideTimer !== null) {
        clearInterval(timers.slideTimer);
        timers.slideTimer = null;
    }

    if (slide.maxSlide > 1) {
        timers.usedTimeScale = timers.slideTimeScale;
        playSlideShow();
        timers.setSlideTimer(timers.slideFrequency);
    } else {
        timers.usedTimeScale = timers.slideTimeScaleSM;
        playSlideShow();
        timers.setSlideTimer(timers.slideFrequencySM);
    }
} //startLargeorSmall -- CHANGES THE SPEED OF THE SLIDE SHOW DEPENDING ON maxSlide





//removeImages -- FADES THEN REMOVES ALL IMAGES THEN CALLS startLargeorSmall TO RE/START SLIDESHOW
function removeImages() {
    var currentImages = document.getElementById('slideShow').getElementsByTagName('IMG');
    if (currentImages.length > 0) {
        var removeCurrentImages = new TimelineLite();
        removeCurrentImages.to(currentImages, 0.2, {
            opacity: 0,
            ease: Power0.easeNone,
            onComplete: function() {
                for (var i = 0; i < currentImages.length; i++) {
                    if (currentImages[i].animateImage) {
                        currentImages[i].animateImage.kill();
                    }
                    currentImages[i].animateImage = false;
                    currentImages[i].runningSlide = null;
                    currentImages[i].style.display = '';
                    currentImages[i].style.opacity = '';
                    currentImages[i].parentNode.removeChild(currentImages[i]);
                };
            }
        });
    }
}


function initiateSlides() {
    if (!misc.initiateSlideSwitchOn) {
        arrays.slideArray = $('.slideShow:visible');
        slide.maxSlide = arrays.slideArray.length;
        misc.initiateSlideSwitchOn = true;
        removeImages();
        var startTimeout = setTimeout(startLargeorSmall, 500);
        timers.resizeDelay = null;
    }
}

//preloaderTimer -- SETS A TIMEOUT BEFORE IT CALLS removeImages();
function preloaderTimer() {
    timers.preloaderDelay = setTimeout(initiateSlides, timers.preloadDelayTime);
} //preloaderTimer -- SETS A TIMEOUT BEFORE IT CALLS removeImages();




//LOOP THROUGH THE IMAGE ARRAY AND CREATE THE IMG OBJECT
(function buildImgObj() {
    for (var i = 1; i <= arrays.imageArray.length; i++) {
        var T = i - 1;
        eval('imgObj.img' + i + ' = new Image();');
        eval('imgObj.img' + i + '.loaded = false;');
        eval('imgObj.img' + i + '.runningSlide = null;');
        eval('imgObj.img' + i + '.onload = function() {' +
            'imgObj.img' + i + '.loaded = true;' +
            // 'console.timeStamp("***img ' + i + ' loaded");' +
            'imageTools.totalImagesLoaded++;' +
            'arrays.loadedArray.push(imgObj.img' + i + ');' +
            'if(imageTools.totalImagesLoaded===slide.maxSlide){' +
            //'console.log(totalImagesLoaded + "preloaderTimer Fired");'+
            'preloaderTimer();}' +
            'if(imageTools.totalImagesLoaded===arrays.imageArray.length){callInitialTween();}};'
        );
        eval('imgObj.img' + i + '.src = "' + arrays.imageArray[T] + '"');
        eval('imgObj.img' + i + '.play = slideController;');
        eval('imgObj.img' + i + '.animateImage = false;');
    }
})();
//LOOP THROUGH THE IMAGE ARRAY AND CREATE THE IMG OBJECT




//ONRESIZE EVENT -- UPDATE SLIDE SHOW
window.onresize = function() {
    if (timers.resizeDelay === null) {
        misc.currentWidth = window.innerWidth;
        if (misc.currentWidth !== misc.previousWidth) {
            misc.previousWidth = misc.currentWidth;
            clearInterval(timers.resizeDelay);
            timers.resizeDelay = setTimeout(initiateSlides, 1000); //Set timeout to remove images and start slideshow
            //misc.initiateSlideSwitchOn = true;
        }
    }
}; //ONRESIZE EVENT -- UPDATE SLIDE SHOW








/*


END slideShow.js
__________________



*/